import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "jspdf-autotable";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class LeaveCategoryTable extends Component {
  componentDidMount() {
    this.setState(() => this.showTable());
  }

  showTable() {
    let table;
    let list = [];
    let obj,
      one = [];
    const leaveCategories = this.props.leaveCategories.filter(
      (leaveCategory) => {
        return !!leaveCategory.allow_carry_forward;
      }
    );

    for (let i = 0; i < leaveCategories.length; i++) {
      obj = leaveCategories[i];
      one = {
        no: i + 1,
        leave_category: obj.leave_category,
        leave_quota: obj.leave_quota,
        max_carry_count: obj.max_carry_count,
      };
      list.push(one);
    }

    if ($.fn.dataTable.isDataTable("#dataTables")) {
      table = $("#dataTables").dataTable({
        destroy: true,
        searching: false,
      });
      table.fnDestroy();
    }

    let column = [
      { title: "No", data: "no" },
      { title: "Leave Category", data: "leave_category" },
      { title: "Leave Quota", data: "leave_quota" },
      { title: "Maximum Carry", data: "max_carry_count" },
    ];

    table = $("#dataTables").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: false,
      searching: false,
      dom: "Bfrtip",
      buttons: [],
      data: list,
      columns: column,
    });
  }

  render() {
    return (
      <div className="margin-y">
        <table
          width="99%"
          className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive rm-marginTop"
          id="dataTables"
        ></table>
      </div>
    );
  }
}
